// components/SonnerProvider.jsx
import React from 'react';
import { Toaster } from 'sonner';

const SonnerProvider = () => {
  return (
    <Toaster
      position="top-right"
      richColors
      closeButton
      duration={3500}
      gap={8}
      theme="light"
      style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
      toastOptions={{
        style: {
          padding: '14px 18px',
          borderRadius: '12px',
          border: '1px solid #f0f0f0',
          boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
          fontSize: '14px',
          maxWidth: '420px',
        },
      }}
    />
  );
};

export default SonnerProvider;